import * as ApiManager from './_manager';
import store from '@/store';

export const affiliation = {
  create: (payload = null) => {
    return ApiManager.callApi(
      `/member/company/${store.getters['company/getSelected']}/referral/create`,
      payload
    );
  },

  list: payload => {
    return ApiManager.callApi(
      `/member/company/${store.getters['company/getSelected']}/referral/list`,
      payload
    );
  },

  get: (payload = null) => {
    return ApiManager.callApi(
      `/member/company/${store.getters['company/getSelected']}/referral/get`,
      payload
    );
  },

  update: payload => {
    return ApiManager.callApi(
      `/member/company/${store.getters['company/getSelected']}/referral/` +
        payload.id +
        `/update`,
      payload
    );
  },

  delete: payload => {
    return ApiManager.callApi(
      `/member/company/${store.getters['company/getSelected']}/affiliation/${payload.id}/delete`,
      payload
    );
  },
};
